import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';

/**
 * Generated class for the DomObserverDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[dom-observer]' // Attribute selector
})
export class DomObserverDirective {
  private changes: MutationObserver;
  @Output() public domChange = new EventEmitter();
  constructor(private elementRef: ElementRef) {
    const element = this.elementRef.nativeElement;

    this.changes = new MutationObserver((mutations: MutationRecord[]) => {
        mutations.forEach((mutation: MutationRecord) => this.domChange.emit(mutation));
      }
    );

    this.changes.observe(element, {
      attributes: true,
      childList: true,
      characterData: true
    });
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }
}



// WEBPACK FOOTER //
// ./src/directives/dom-observer/dom-observer.ts